// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
// TODO. Base class?
export class SLTPError {
    constructor(type, minOrMaxPossibleValue) {
        this.type = type;
        this.minOrMaxPossibleValue = minOrMaxPossibleValue;
    }
    equals(sltpError) {
        if (isNullOrUndefined(sltpError)) {
            return false;
        }
        if (this === sltpError) {
            return true;
        }
        return this.type === sltpError.type && this.minOrMaxPossibleValue === sltpError.minOrMaxPossibleValue;
    }
    toString() {
        switch (this.type) {
            case SLTPErrorType.LessMin:
                return Resources.getResource('UserControl.TerceraNumeric.ValueLessMin') + this.minOrMaxPossibleValue;
            case SLTPErrorType.MoreMax:
                return Resources.getResource('UserControl.TerceraNumeric.ValueGreaterMax') + this.minOrMaxPossibleValue;
            default:
                return '';
        }
    }
}
export var SLTPErrorType;
(function (SLTPErrorType) {
    SLTPErrorType[SLTPErrorType["LessMin"] = 1] = "LessMin";
    SLTPErrorType[SLTPErrorType["MoreMax"] = 2] = "MoreMax";
})(SLTPErrorType || (SLTPErrorType = {}));
